import Dropdown from 'react-dropdown';
import { useTranslation } from "react-i18next";
//import { CSVLink } from 'react-csv';

const DropDown = (props: any) => {
	const { t } = useTranslation();

	const arrowClosed = (
		<span className="arrow-closed" />
	)

	const arrowOpen = (
		<span className="arrow-open" />
	)

	return <Dropdown
		arrowClosed={arrowClosed}
		arrowOpen={arrowOpen}
		options={props.options}
		value={props.value}
		onChange={(d) => {
			props.onChange(d)
		}}
		className={props.className ?? 'download'}
		disabled={props.disabled}
		placeholder={props.placeholder ?? t("select")}
	/>
}

export default DropDown;
